const metricsPage = {
    begin: 'BEGIN_REGISTRATION',
    confirmPolicy: 'CONFIRM_POLICIES',
    contactInfo: 'CONTACT_INFORMATION',
    createProfile: 'CREATE_A_PROFILE',
    accessPremiumAudit: 'ACCESS_PREMIUM_AUDIT'
};

const categoryIdList = {
    pageViewId: 'PA-REGISTRATION',
    continueBtnCatId: 'PAREG-CLICKS',
    errorCatId: 'PAREG-ERROR'
};

function metricsElementTag(elementId, isError) {
    if (isError) {
        const maxLength = 50;
        const trimmedErrorMsg =
            elementId.length > maxLength
                ? elementId.substring(0, maxLength - 3) + '...'
                : elementId;
        try {
            // eslint-disable-next-line no-undef
            cmCreateElementTag(trimmedErrorMsg, categoryIdList.errorCatId);
        } catch (err) {
            //do nothing...eat the exception
        }
    } else {
        try {
            // eslint-disable-next-line no-undef
            cmCreateElementTag(
                'PAREG_CLICK_CONTINUE_' + elementId,
                categoryIdList.continueBtnCatId
            );
        } catch (err) {
            //do nothing...eat the exception
        }
    }
}

function metricsCancelClickTag(pageId) {
    try {
        // eslint-disable-next-line no-undef
        cmCreateElementTag(
            'PAREG_CLICK_CANCEL',
            categoryIdList.continueBtnCatId,
            '-_--_--_--_--_--_-' + pageId
        );
    } catch (err) {
        //do nothing...eat the exception
    }
}

function metricsPageViewTag(pageId) {
    try {
        // eslint-disable-next-line no-undef
        cmCreatePageviewTag(pageId + '_PAREG', categoryIdList.pageViewId);
    } catch (err) {
        //do nothing...eat the exception
    }
}

export { metricsElementTag, metricsPageViewTag, metricsCancelClickTag, metricsPage };
